import { Component, Input } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NumberFormatSeparator } from 'enums-lib';
import { EmptyFieldType } from '../adv2-config';
import { createEmptyFieldGroup } from './empty-fields.util';

/**
 * Field Options tab of the AwesomeDocs config dialog: the corp-wide default date
 * format, the corp-wide default number format and the blank-field defaults.
 *
 * Presentational only - it renders the `fieldOptions` sub-group handed to it by
 * Adv2ConfigComponent, which remains responsible for loading and saving.
 */
@Component({
  selector: 'app-field-options-tab',
  templateUrl: './field-options-tab.component.html',
  styleUrls: ['./field-options-tab.component.scss'],
  standalone: false,
})
export class FieldOptionsTabComponent {
  @Input() formGroup: UntypedFormGroup;

  readonly emptyFieldType = EmptyFieldType;
  readonly emptyFieldSelect = Object.keys(EmptyFieldType);
  readonly numberFormatSeparator = NumberFormatSeparator;

  get emptyFieldsFormArray(): UntypedFormArray {
    return this.formGroup.get('emptyFields') as UntypedFormArray;
  }

  onAddEmptyFieldClick(): void {
    this.emptyFieldsFormArray.push(createEmptyFieldGroup());
  }

  onRemoveClick(i: number): void {
    this.emptyFieldsFormArray.removeAt(i);
    this.emptyFieldsFormArray.markAsDirty();
  }

  getFormControl(i: number, controlName: string): UntypedFormControl {
    return this.emptyFieldsFormArray.controls[i].get(controlName) as UntypedFormControl;
  }
}
